export default "__VITE_ASSET__RBqqlYxF__"